import React from "react";
import useHotkey from "hooks/useHotkey";
const HotkeyComponent = ({ shortcut }) => {
  useHotkey(shortcut);
  return null;
};
const KeyCapture = ({ children = null, shortcuts }) => /* @__PURE__ */ React.createElement(React.Fragment, null, shortcuts.map((shortcut) => /* @__PURE__ */ React.createElement(HotkeyComponent, { key: `${shortcut.scope}.${shortcut.actionKey}`, shortcut })), children);
export default KeyCapture;
